import { EnvironmentService, Environment } from '@galaxy/core';
import { Injectable } from '@angular/core';

@Injectable()
export class BillingErpUrlService {
  private _host: string;

  constructor(private environmentService: EnvironmentService) {}

  private getFinancialForceHost(): void {
    if (this._host) {
      return;
    }

    switch (this.environmentService.getEnvironment()) {
      case Environment.PROD: {
        this._host = '//na102.lightning.force.com';
        break;
      }

      case Environment.DEMO: {
        this._host = '//cs3.lightning.force.com';
        break;
      }

      default: {
        this._host = '//cs3.lightning.force.com';
        break;
      }
    }
  }

  private getNetSuiteHost(): void {
    if (this._host) {
      return;
    }

    switch (this.environmentService.getEnvironment()) {
      case Environment.PROD: {
        this._host = '//4336003.app.netsuite.com';
        break;
      }

      case Environment.DEMO: {
        this._host = '//4336003-sb2.app.netsuite.com';
        break;
      }

      default: {
        this._host = '//4336003-sb2.app.netsuite.com';
        break;
      }
    }
  }

  public getSalesInvoiceDetails(invoiceId: string): string {
    this.getNetSuiteHost();
    return `${this._host}/app/accounting/transactions/custinvc.nl?id=${invoiceId}`;
  }

  public getSalesCreditNoteDetails(creditNoteId: string): string {
    this.getNetSuiteHost();
    return `${this._host}/app/accounting/transactions/custcred.nl?id=${creditNoteId}`;
  }

  public getBankReconciliationStatementList(): string {
    this.getFinancialForceHost();
    return `${this._host}/lightning/o/c2g__codaBankReconciliation__c/list`;
  }
}
